import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { routes } from '@libs/utils';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { OnboardingVideoComponent } from 'libs/onboarding/src/lib/onboarding-modal/steps/onboarding-video/onboarding-video.component';
import { SiteSetupComponentService, StepNumberEnum } from '../../site-setup/site-setup.component.service';
import { siteSetupVideos } from '../../site-setup-videos';

@Component({
  selector: 'lib-server-installation-video',
  imports: [CommonModule, TranslateModule, OnboardingVideoComponent],
  templateUrl: './server-installation-video.component.html',
  styleUrl: './server-installation-video.component.scss',
})
export class ServerInstallationVideoComponent {
  private readonly service = inject(SiteSetupComponentService);
  private readonly router = inject(Router);
  public vm = this.service.viewModel;

  public routes = routes;
  public StepNumberEnum = StepNumberEnum;
  public serverVideo = siteSetupVideos[2];

  public next(): void {
    this.service.setContractActiveStep({
      step: StepNumberEnum.ServerInstallationChecklist,
    });
    this.service.setActiveStep(StepNumberEnum.ServerInstallationChecklist);
    this.router.navigate([routes.setup, routes.serverInstallation, routes.checklist]);
  }
}
